import React, { useEffect } from "react";
import "../styles/default.css";
import "../styles/market.css";
import "../styles/responsive.css";
import "../styles/home.css";
import Footer from "./common/Footer.jsx";
import Navbar from "./common/Navbar.jsx";

function School() {
  useEffect(() => {
    // Scroll event listener
    const handleScroll = () => {
      const elements = document.querySelectorAll(".toshow");

      elements.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const showPoint = 5;

        if (elementTop < windowHeight - showPoint) {
          element.classList.add("toshowactive");
        } else {
          element.classList.remove("toshowactive");
        }
      });
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="homeMainContainer">
      <Navbar />
      <div className="secondMainNav ibloSchoolTitl revonMob">
        <div className="rightCont">
          <div className="theTitle title"> IBLoTec School </div>
          IBlotec school is a dynamic educational institution committed to
          providing student with a well-rounded education that prepares them for
          a success in a rapidly changing world. we strive to create an
          environment that fosters critical thinking, creativity, and
          collaboration, and our experience faculty members are passionate in
          helping each student reach their full potential. with a wide range of
          extracurricular activities and a diverse and inclusive community,
          IBlotec school is the perfect place for student to discover their
          passions and prepare for a bright future
          <a href="#masterClass" className="btn2 riCon ">
            {" "}
            See Formations
          </a>
        </div>
        <div className="leftCont">
          <img src="../images/schoo1l.jpg" alt="" />
        </div>
      </div>

      <div className="secondMainNav par revonMob" id="masterClass">
        <div className="rightCont">
          <div className="theTitle title"> Crypto Master C</div>
          crypto Master className is a comprehensive trading education program
          that introduces individuals to the world of cryptocurrencies, catering
          to beginners and those with limited knowledge. Our curriculum provides
          a clear understanding of the mecanics of a crypto trading.
          Additionally, we highlight the numerous opportunities available in
          crypto market including investment portiral.
          <div className="btn2 riCon"> join Now</div>
        </div>
        <div className="leftCont">
          <img src="../images/coding.jpg" alt="" />
        </div>
      </div>

      <div className="secondMainNav toshow" id="ForexSchool">
        <div className="leftCont">
          <img src="../images/school.jpg" alt="" />
        </div>
        <div className="rightCont">
          <div className="title"> Trading Forex</div>
          IBLoTec School gives the opportunity to join the best trading
          education program at differents levels from beginner to professional
          in the french and english speaking community.
          <div className="btn2 riCon"> Join now</div>
        </div>
      </div>

      <div className="secondMainNav toshow revonMob" id="coachingSchool">
        <div className="rightCont">
          <div className="theTitle title"> COACHING</div>
          Are you ready to achive your goals and unlock your true potential? Our
          coaching sessions are designed to help you to take action towards
          creating a life you love and are proud of.
          <div className="btn2 riCon"> join Now</div>
        </div>
        <div className="leftCont">
          <img src="../images/Coaching.png" alt="" />
        </div>
      </div>

      <div className="secondMainNav toshow" id="programmingSchool">
        <div className="leftCont">
          <img src="../images/programming.jpg" alt="" />
        </div>
        <div className="rightCont">
          <div className="title"> Programming Courses</div>
          Are you ready to transform your ideas into reality and unlock your
          potential as a programmer? Our Programming Course is designed to help
          you to create innovative and impactful solutions, build a solid
          foundation in programming.
          <div className="btn2 riCon"> Join now</div>
        </div>
      </div>

      <div className="secondMainNav toshow revonMob" id="digitalsSchool">
        <div className="rightCont">
          <div className="theTitle title"> DIGITALS</div>
          Are you ready to unlock the power of digital technology and expand
          your digital knowledge and expertise? Our difital course is designed
          to help you learn essentials digital skills, discover new and exciting
          digitals tools.
          <div className="btn2 riCon"> join Now</div>
        </div>
        <div className="leftCont">
          <img src="../images/digital.jpg" alt="" />
        </div>
      </div>

      <div className="secondMainNav toshow" id="metaverseSchool">
        <div className="leftCont">
          <img src="../images/metaverse.jpg" alt="" />
        </div>
        <div className="rightCont">
          <div className="title"> METAVERSE</div>
          Are you ready to explore the limitless potential of the metaverse? our
          metaverse course is designed to help you create immersive and engaging
          virtual experiences,unlock your creativity and imagination, and build
          a solid foundation in metaverse technology.
          <div className="btn2 riCon"> Join now</div>
        </div>
      </div>

      <div className="pricesTable">
        <div className="priceTitle"> OUR PRICING</div>
        <div className="pricesCont">
          <a href="#ForexSchool" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">TRADING FOR BEGINNER</span>
              <span className="courseprice">$49.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </a>

          <div className="priceblock">
            <div className="priceInfo">
              <span className="coursename">TRADING FOR ADVANCED</span>
              <span className="courseprice">$150.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </div>

          <a href="#coachingSchool" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">COACHING</span>
              <span className="courseprice">$200.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </a>

          <div className="priceblock">
            <div className="priceInfo">
              <span className="coursename">DRONE</span>
              <span className="courseprice">$ 220.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </div>
          <div className="priceblock">
            <div className="priceInfo">
              <span className="coursename">PRODUCTION</span>
              <span className="courseprice">$330.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </div>

          <a href="#metaverseSchool" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">METAVERSE</span>
              <span className="courseprice">$180.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </a>

          <a href="#masterClass" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">CRYPTO MASTER CLASSName</span>
              <span className="courseprice">$50.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </a>

          <a href="#digitalsSchool" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">DIGITALS</span>
              <span className="courseprice">$300.95</span>
              <span className="courselegend">PER LIFE TIME</span>
            </div>
            <div className="btn1 joinbtnprice"> JOIN THE TRAINING</div>
          </a>

          <a href="#programmingSchool" className="priceblock">
            <div className="priceInfo">
              <span className="coursename">PROGRAMMING COURSES</span>
              <span className="courseprice"></span>
              <span className="courselegend">
                Contact Admin for pricing and ther Details
              </span>
            </div>
            <div className="btn1 joinbtnprice"> CONTACT ADMIN</div>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default School;
